import { useCallback, useEffect, useRef, useState } from 'react'

function useStateCallback(data) {
  const [state, setState] = useState(data)
  const callbackRef = useRef()

  const setStateCallback = useCallback((newState, callback) => {
    setState(prevState => {
      if (typeof callback === 'function') {
        callbackRef.current = callback
      }
      return typeof newState === 'function' ? newState(prevState) : newState
    })
  }, [])

  useEffect(() => {
    if (typeof callbackRef.current === 'function') {
      callbackRef.current(state)
      callbackRef.current = null
    }
  }, [state])

  return [state, setStateCallback]
}

export default useStateCallback
